/**
 * Formatea una fecha al formato español DD-MM-YYYY
 * @param {string|Date} date - Fecha en formato ISO, Date object, DD-MM-YYYY, o string
 * @returns {string} Fecha formateada en DD-MM-YYYY o '-' si no hay fecha
 */
export const formatDateToSpanish = (date) => {
  if (!date) return '-';
  
  try {
    // Si ya está en formato DD-MM-YYYY (por ejemplo: "20-12-2025"), devolverlo tal cual
    if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
      return date;
    }
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Verificar si la fecha es válida
    if (isNaN(dateObj.getTime())) return '-';
    
    // Usar UTC para evitar problemas de zona horaria
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const year = dateObj.getUTCFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

/**
 * Convierte una fecha del formato español DD-MM-YYYY al formato ISO YYYY-MM-DD para inputs tipo date
 * @param {string} spanishDate - Fecha en formato DD-MM-YYYY
 * @returns {string} Fecha en formato YYYY-MM-DD
 */
export const spanishDateToISO = (spanishDate) => {
  if (!spanishDate || spanishDate === '-') return '';
  
  try {
    const parts = spanishDate.split('-');
    if (parts.length !== 3) return '';
    
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting date to ISO:', error);
    return '';
  }
};

/**
 * Convierte una fecha del formato ISO YYYY-MM-DD al formato español DD-MM-YYYY
 * @param {string} isoDate - Fecha en formato YYYY-MM-DD
 * @returns {string} Fecha en formato DD-MM-YYYY
 */
export const isoDateToSpanish = (isoDate) => {
  if (!isoDate) return '-';
  
  try {
    const parts = isoDate.split('-');
    if (parts.length !== 3) return '-';
    
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.error('Error converting ISO date to Spanish:', error);
    return '-';
  }
};

/**
 * Obtiene la fecha actual en formato YYYY-MM-DD para inputs tipo date
 * @returns {string} Fecha actual en formato YYYY-MM-DD
 */
export const getTodayISO = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
